import { render, staticRenderFns } from "./SurveyResultAnswer.vue?vue&type=template&id=25ed2743&scoped=true&"
import script from "./SurveyResultAnswer.vue?vue&type=script&lang=js&"
export * from "./SurveyResultAnswer.vue?vue&type=script&lang=js&"
import style0 from "./SurveyResultAnswer.vue?vue&type=style&index=0&id=25ed2743&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ed2743",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCheckbox,VRadio,VRadioGroup,VTextarea})
